import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { JuniorLevel } from './JuniorLevel';
import { SeniorLevel } from './SeniorLevel';
import { CadetLevel } from './CadetLevel';
import { KidsLevel } from './KidsLevel';
import { OlympicCategory } from './OlympicCategory';
import { ParaTaekwondo } from './ParaTaekwondo';
const DIVISIONS = ['Junior Level', 'Senior Level', 'Cadet Level', 'Kids Level', 'W.T.F. Olympic Category', 'W.T.F. Para Taekwondo'] as const;
type Division = (typeof DIVISIONS)[number];
/**
 * Division dropdown + the matching division section.
 *
 * Owns its own selectedDivision state internally and renders the
 * corresponding division section below the dropdown — no props.
 */
export function DivisionSelector() {
  const [selectedDivision, setSelectedDivision] = useState<Division>('Junior Level');
  return <>
      <div className="max-w-md mx-auto mb-12" data-id="element-846">
        <label htmlFor="division-select" className="block text-sm font-bold text-gray-700 mb-2 text-center uppercase tracking-wider" data-id="element-847">
          Select Division
        </label>
        <div className="relative" data-id="element-848">
          <select id="division-select" value={selectedDivision} onChange={e => setSelectedDivision(e.target.value as Division)} className="block w-full appearance-none bg-white border border-gray-300 text-gray-900 py-3 px-4 pr-8 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 font-semibold text-lg cursor-pointer transition-colors hover:border-blue-400" data-id="element-849">
            {DIVISIONS.map(division => <option key={division} value={division} data-id="element-850">
                {division}
              </option>)}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-500" data-id="element-851">
            <ChevronDownIcon className="h-5 w-5" data-id="element-852" />
          </div>
        </div>
      </div>

      {selectedDivision === 'Junior Level' && <JuniorLevel data-id="element-853" />}
      {selectedDivision === 'Senior Level' && <SeniorLevel data-id="element-854" />}
      {selectedDivision === 'Cadet Level' && <CadetLevel data-id="element-855" />}
      {selectedDivision === 'Kids Level' && <KidsLevel data-id="element-856" />}
      {selectedDivision === 'W.T.F. Olympic Category' && <OlympicCategory data-id="element-857" />}
      {selectedDivision === 'W.T.F. Para Taekwondo' && <ParaTaekwondo data-id="element-858" />}
    </>;
}